// The game's season — the single source of truth for everything seasonal
// (the Halloween shop tab, the autumn loading cover, …).
//
// Meteorological seasons by UTC month, so every player and the backend agree on
// the switch moment (the backend has the same table: app/season.py).

export type Season = 'winter' | 'spring' | 'summer' | 'autumn';

const SEASON_BY_UTC_MONTH: readonly Season[] = [
  'winter', 'winter', // Jan, Feb
  'spring', 'spring', 'spring', // Mar–May
  'summer', 'summer', 'summer', // Jun–Aug
  'autumn', 'autumn', 'autumn', // Sep–Nov
  'winter', // Dec
];

const SEASONS: readonly Season[] = ['winter', 'spring', 'summer', 'autumn'];

/** DEV only: localStorage `debug_season` = winter|spring|summer|autumn previews another season. */
function devOverride(): Season | null {
  if (!import.meta.env?.DEV) return null;
  try {
    const v = localStorage.getItem('debug_season');
    return SEASONS.includes(v as Season) ? (v as Season) : null;
  } catch {
    return null;
  }
}

export function seasonAt(date: Date): Season {
  return SEASON_BY_UTC_MONTH[date.getUTCMonth()];
}

/** The season right now. */
export function currentSeason(now: Date = new Date()): Season {
  return devOverride() ?? seasonAt(now);
}
